// Manage Coffee subscription duration from query string
function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

// ?subLength=7

window.onload = function() {
    
    

    var reChargeDuration = getUrlVars()["subLength"];

    console.log(reChargeDuration);

    if (typeof reChargeDuration != 'undefined') {
        $('.rc_select__frequency option[value=' + reChargeDuration + ']').prop('selected', true);

        if($('.rc_block__type__onetime').length != 0) {
            $('input.rc_radio__autodeliver').prop('checked', true);
            $('label.rc_label__autodeliver').trigger('click'); 
        }
    }
}
